export default "assets/images/icons/instagram-13ce64aa.svg";